import { HttpClient } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, CheckAdmin, LoginResponse } from './types/api-schema.types';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private wallet = signal<string>(localStorage.getItem('walletAddress') || ''); // Signal to hold the wallet address
  address = computed(() => this.wallet());  


  constructor(private http: HttpClient,private localStorageService: LocalStorageService) {}

  adminLogin(walletAddress: string): Observable<ApiResponse<LoginResponse>> {
    return this.http.post<ApiResponse<LoginResponse>>(`${environment.API_BASE_URL}/admin/login`, { wallet_address: walletAddress});
  }

  checkValidAdmin(walletAddress: string): Observable<ApiResponse<CheckAdmin>> {
    return this.http.get<ApiResponse<CheckAdmin>>(`${environment.API_BASE_URL}/admin/check-admin/${walletAddress}`);
  }

  /**
   * Sets token
   * @param token 
   */

  setToken(token: string): void {
    this.localStorageService.storeData('accessToken', token);
  }

  /**
   * Gets token
   * @returns token 
   */
  getToken(): string | null {
    return this.localStorageService.getDataByKey('accessToken');
  }

  /**
   * Removes token
   * @returns  
   */
  removeToken() {
    return localStorage.removeItem('accessToken');
  }

  /**
   * Signs out
   * @returns out 
   */
  signOut(): Observable<ApiResponse<LoginResponse>> {
    return  this.http.delete<ApiResponse<LoginResponse>>(`${environment.API_BASE_URL}/admin/logout`);
  }

/**
 * Retrieves the wallet address from local storage.
 * Sets the retrieved wallet address in the wallet signal.
 * @returns The wallet address as a string, or an empty string if not found.
 */
  getWalletAddress(): string {
    this.wallet.set(localStorage.getItem('walletAddress') || '');
    return localStorage.getItem('walletAddress') || '';
  }

 
}
